import { useExt } from "./ext";
import { usePlayer } from "./player";

export function useRelics(unit) {

    const ext = useExt();
    const player = usePlayer();
    const usedRelics = player.usedRelics.map(r => r.name.toLowerCase())

    const ret = {}
    Object.keys(ext.relics).forEach(type => {
        if (type === 'antiquity' && unit.grade !== 'heroic' && unit.grade !== 'legendary') {
            return;
        }
        if (type === 'legendary' && unit.grade !== 'legendary') {
            return;
        }
        const filtered = ext.relics[type].filter(tr => {
            const match_a = tr.keywords_a.filter(ca => unit.categories.includes(ca)).length == tr.keywords_a.length;
            const match_r = tr.keywords_r.filter(cr => unit.categories.includes(cr)).length == 0

            return match_a && match_r;
        }).filter(r => !r.unique || !usedRelics.includes(r.name.toLowerCase()))
        if (filtered.length > 0) {
            ret[type] = filtered;
        }
    })

    return ret;
}